<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-tabs v-model="active" @change="onTabChange">
      <van-tab title="进行中" name="RUN" />
      <van-tab title="即将开始" name="WAIT" />
      <van-tab title="已完成" name="FINISH" />
      <van-tab title="已过期" name="OVERDUE" />
      <van-tab title="不限" name="NONE" />
    </van-tabs>
    <van-skeleton :row="18" :loading="loadingPage">
      <div class="backRect">
        <div v-for="(item,index) in list" :key="index" class="baseRect" @click="onSelectRule(item.rule.ruleId)">
          <van-row>
            <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">项目</span>{{ item.rule.title }}</van-col>
            <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">开始时间</span>{{ formatDate(item.rule.startTime,'yyyy/MM/dd hh:mm') }}</van-col>
          </van-row>
          <van-row>
            <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">需要反馈</span>
              <van-tag v-if="item.rule.isNeedFeedback" type="success">需要</van-tag>
              <van-tag v-if="!item.rule.isNeedFeedback" type="danger">不需要</van-tag>
            </van-col>
            <van-col v-if="item.rule.isNeedFeedback" span="12" class="line"><span :style="'color:'+GetColorMainBack()">是否反馈</span>
              <template v-if="item.rule.isNeedFeedback && item.result">
                <van-tag type="success" style="margin-right:0.5em">已反馈</van-tag>
                <van-tag v-if="item.result.state==='WAIT'" type="primary" plain>  {{ GetEnumText('SignState', item.result.state) }}</van-tag>
                <van-tag v-if="item.result.state==='SUCCESS'" type="success">  {{ GetEnumText('SignState', item.result.state) }}</van-tag>
                <van-tag v-if="item.result.state==='FALSE'" type="danger">  {{ GetEnumText('SignState', item.result.state) }}</van-tag>

              </template>
              <van-tag v-if="item.rule.isNeedFeedback && !item.result" type="danger">未反馈</van-tag>
            </van-col>
          </van-row>
          <van-row v-if="item.startTimeBeginTime>0">
            <van-col span="24" class="line"><span :style="'color:'+GetColorMainBack()">即将开始</span>
              <van-count-down
                style="display: inline-block;"
                :time="item.startTimeBeginTime"
                :format="item.startTimeBeginTime>86400000?'DD天HH时mm分ss秒':'HH时mm分ss秒'"
              />
            </van-col>
          </van-row>
          <van-row>
            <van-col span="24" class="line"><span :style="'color:'+GetColorMainBack()">说明</span>{{ item.rule.remark }}</van-col>
          </van-row>
        </div>
      </div>
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Tab, Tabs, Skeleton, CountDown, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Skeleton.name]: Skeleton,
    [CountDown.name]: CountDown,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '宣传资料列表',
      loadingPage: true,
      active: 'RUN',
      backurl: '/pro/index',
      list: []
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.loading()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onTabChange(name) {
      this.loading()
    },
    loading() {
      this.loadingPage = true
      request({
        url: '/Propaganda/GetProPropagandaList',
        method: 'post',
        params: { type: this.active }
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.list = response.data
      })
    },
    onSelectRule(ruleId) {
      this.$router.push('/pro/propaganda/' + ruleId)
    }
  }
}
</script>
<style scoped>
.baseRect{
    background-color: #fff;
    padding: 1em;
    margin:1em;
    border-radius: 0.4em;
}
.baseRect .line{
    font-size: 0.8em;
    line-height: 1.8em;
}
.baseRect .line span{
    font-weight: 700;
    padding-right: 0.5em;
}
</style>
